/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Home_Review_ConsInputs */

const en_fc_home_review_cons = /** @type {(inputs: Fc_Home_Review_ConsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limits`)
};

/**
* | output |
* | --- |
* | "Limits" |
*
* @param {Fc_Home_Review_ConsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_home_review_cons = /** @type {((inputs?: Fc_Home_Review_ConsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Home_Review_ConsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_home_review_cons(inputs)
});
export { fc_home_review_cons as "fc.home.review.cons" }